module.exports = __webpack_public_path__ + "static/Resin Veneers intraoral after -ca8f703f59485ab59e5e0ebfd4598888.jpg";